import { render } from "./AdminUserCreationScreen.vue?vue&type=template&id=63a03ede&scoped=true"
import script from "./AdminUserCreationScreen.vue?vue&type=script&lang=js"
export * from "./AdminUserCreationScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=63a03ede&lang=scss&scoped=true"
import "./AdminUserCreationScreen.vue?vue&type=style&index=1&id=63a03ede&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.8\\installer\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a03ede"]])

export default __exports__